import { RingFinishEnum } from '@/app/enums/RingFinishEnum';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';

import wizardData from '.';
import type { WizardCarouselImage } from './types';

type JapaneseRegionalImageOverrideData = {
  [key in RingFinishEnum]: WizardCarouselImage[] | null;
};

function getRemainderCarouselImages(
  finish: RingFinishEnum,
): WizardCarouselImage[] {
  return (
    wizardData[RingStyleEnum.OuraRing4][finish]?.finishStep?.carouselImages ??
    []
  ).slice(1) as WizardCarouselImage[]; // Exclude the first image
}

export const japaneseRegionalImageOverrideData: JapaneseRegionalImageOverrideData =
  {
    [RingFinishEnum.Black]: [
      {
        altMsgKey: 'woman_hand_img_alt',
        contentTitle: null,
        content: null,
        inverseText: true,
        mobileSrc: 'ja-regional/black-mobile.jpg',
        originalSrc: 'ja-regional/black-desktop.jpg',
        thumbnailSrc: 'ja-regional/black-desktop.jpg',
        originalSrcKey: null,
      },
      ...getRemainderCarouselImages(RingFinishEnum.Black),
    ],
    [RingFinishEnum.BrushedSilver]: [
      {
        altMsgKey: 'man_taking_photo_img_alt',
        contentTitle: null,
        content: null,
        inverseText: true,
        mobileSrc: 'ja-regional/brushed-silver-mobile.jpg',
        originalSrc: 'ja-regional/brushed-silver-desktop.jpg',
        thumbnailSrc: 'ja-regional/brushed-silver-desktop.jpg',
        originalSrcKey: null,
      },
      ...getRemainderCarouselImages(RingFinishEnum.BrushedSilver),
    ],
    [RingFinishEnum.Gold]: [
      {
        altMsgKey: 'hand_pocket_img_alt',
        content: null,
        contentTitle: null,
        inverseText: true,
        mobileSrc: 'ja-regional/gold-mobile.jpg',
        originalSrc: 'ja-regional/gold-desktop.jpg',
        thumbnailSrc: 'ja-regional/gold-desktop.jpg',
        originalSrcKey: null,
      },
      ...getRemainderCarouselImages(RingFinishEnum.Gold),
    ],
    [RingFinishEnum.Rose]: null,
    [RingFinishEnum.RoseGold]: [
      {
        altMsgKey: 'woman_hand_img_alt',
        content: null,
        contentTitle: null,
        inverseText: true,
        mobileSrc: 'ja-regional/rose-gold-mobile.jpg',
        originalSrc: 'ja-regional/rose-gold-desktop.jpg',
        thumbnailSrc: 'ja-regional/rose-gold-desktop.jpg',
        originalSrcKey: null,
      },
      ...getRemainderCarouselImages(RingFinishEnum.RoseGold),
    ],

    [RingFinishEnum.Silver]: [
      {
        altMsgKey: 'man_tie_img_alt',
        content: null,
        contentTitle: null,
        inverseText: true,
        mobileSrc: 'ja-regional/silver-mobile.jpg',
        originalSrc: 'ja-regional/silver-desktop.jpg',
        thumbnailSrc: 'ja-regional/silver-desktop.jpg',
        originalSrcKey: null,
      },
      ...getRemainderCarouselImages(RingFinishEnum.Silver),
    ],

    [RingFinishEnum.Stealth]: [
      {
        altMsgKey: 'man_cheese_img_alt',
        content: null,
        contentTitle: null,
        inverseText: true,
        mobileSrc: 'ja-regional/stealth-mobile.jpg',
        originalSrc: 'ja-regional/stealth-desktop.jpg',
        thumbnailSrc: 'ja-regional/stealth-desktop.jpg',
        originalSrcKey: null,
      },
      ...getRemainderCarouselImages(RingFinishEnum.Stealth),
    ],

    [RingFinishEnum.Titanium]: null,
  };
